import { XIcon } from "@heroicons/react/outline";
import * as React from "react";
import { useTranslation } from "react-i18next";
import { type OfflineTaskUpload } from "~/config/offline-storage/offlineTaskUploads.store";
import { Box } from "~/design-system/Box";
import { Button } from "~/design-system/Button";
import { Text } from "~/design-system/Text";

interface ErrorUploadItemProps {
  upload: OfflineTaskUpload;
  isExpanded: boolean;
  onToggleExpansion: (uploadId: string) => void;
  onRemove: (upload: OfflineTaskUpload) => void;
}

export const ErrorUploadItem: React.FC<ErrorUploadItemProps> = ({
  isExpanded,
  onRemove,
  onToggleExpansion,
  upload,
}) => {
  const { t } = useTranslation();

  return (
    <Box>
      <Box
        css={{
          alignItems: "center",
          display: "flex",
          gap: "$xxsmall",
          justifyContent: "space-between",
        }}
      >
        <Box css={{ flex: 1, minWidth: 0 }}>
          <Text
            size="xsmall"
            tone="neutral"
            css={{
              cursor: "pointer",
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
            }}
            onClick={() => onToggleExpansion(upload.id)}
          >
            {upload.fileName}
          </Text>
        </Box>
        <Button
          size="xsmall"
          variant="ghost"
          circular
          onClick={() => onRemove(upload)}
          iconLabel="Remove file"
        >
          <XIcon height={12} width={12} />
        </Button>
      </Box>
      {isExpanded && upload.errorMessage && (
        <Box
          css={{
            backgroundColor: "$critical50",
            border: "1px solid $critical200",
            borderRadius: "$small",
            marginTop: "$xxsmall",
            padding: "$xxsmall",
          }}
        >
          <Text size="xsmall" tone="critical">
            {upload.errorMessage}
          </Text>
          {upload.retryCount > 0 && (
            <Text size="xsmall" tone="neutral" css={{ marginTop: "$xxsmall" }}>
              Retry attempts: {upload.retryCount}
            </Text>
          )}
        </Box>
      )}
    </Box>
  );
};
